























import { Component, Vue } from 'vue-property-decorator';

import AppNav from '@/components/AppNav/AppNav.vue';
import AppList from '@/components/AppList/AppList.vue';

@Component({
  components: {
    AppNav,
    AppList,
  },
  name: 'AppBar',
})
export default class AppBar extends Vue {
  get progressActive(): boolean {
    const { apps, error } = this.$store.state['app-data'];
    return !apps.length && error === null;
  }

  get navigationDrawerWidth(): number | string {
    return this.$route.name === 'Home' ? '100%' : 358;
  }
}
